export default __webpack_public_path__ + "static/media/blog_table.8c842277.webp";